
import { Account } from './../interfaces/account.model';
import { ApiService } from './../services/api.service';
import { ResponseService } from './../services/response.service';
import { Component, OnInit } from '@angular/core';
import { Logon } from './../interfaces/logon.model';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'logon-account',
  templateUrl: './logon-details-account.component.html',
})
export class LogonDetailsAccountComponent implements OnInit {

  id : number;
  private sub: any;
  loadingLogon : Boolean = true;

  logon : Logon;
  p: number = 1;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private responseService: ResponseService
  ) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.id = params['id'];


      this.apiService.get('/logons/'+this.id).subscribe(
        (response) => {
          this.logon = this.responseService.success(false, response, 'logon');
          this.loadingLogon = false;
        },
        (error) => {
          this.responseService.error(error);
        }
        
      );
    });
    


    
    
  }

  ngOnDestroy() {
    //this.sub.unsubscibe();
  }

  
}



// WEBPACK FOOTER //
// ./src/app/account/logon-details-account.component.ts